// © Microsoft Corporation. All rights reserved.

export const FollowButtonStyles = {
    followButtonContainer: {
        "min-width": "100px"
    }
};